import { useQuery } from '@tanstack/react-query';
import { getCompanyContactAndSupports } from 'api/companies';
import { companyKeys } from 'api/queryKeys';
import { useMainCompanyQuery } from './useMainCompanyQuery';

export const useCompanyContactAndSupportsQuery = () => {
  const { data: mainCompany } = useMainCompanyQuery();
  const companyId = mainCompany?.id ?? '';

  return useQuery({
    queryKey: companyKeys.contactAndSupports(companyId),
    queryFn: () =>
      getCompanyContactAndSupports(companyId).then((res) => res.data ?? []),
    enabled: !!companyId
  });
};
